import StarCircle from '../../src/legacy/StarCircle.tsx';
export default StarCircle;
